import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './RFTerminal.css';
import { FaBoxes, FaClipboardList, FaSignOutAlt, FaTerminal, FaUserCircle, FaWarehouse } from 'react-icons/fa';

const RFTerminal = () => {
  const [input, setInput] = useState('');
  const [error, setError] = useState('');
  const [screen, setScreen] = useState({
    title: 'RF Web',
    menu: [
      { key: '01', label: ' 01 RCV ORDER' },
      { key: '02', label: ' 02 PUTAWAY' },
    ],
    option: '01',
    footer: 'OPTION [01]'
  });

  const navigate = useNavigate();

  const menuOptions = [
    { id: '01', label: 'RCV ORDER' },
    { id: '02', label: 'PUTAWAY' },
    { id: '99', label: 'LOGOFF' }
  ];

  const handleKeyPress = (value) => {
    if (value === 'ENT') {
      handleEnter();
    } else if (value === 'CLR') {
      setInput('');
    } else if (value === 'BSP') {
      setInput(prev => prev.slice(0, -1));
    } else if (value === 'NXT') {
      // Handle next page
    } else if (value === 'EXT') {
      navigate('/');
    } else {
      setInput(prev => prev + value);
    }
  };

  const handleEnter = () => {
    switch (input) {
      case '01':
        navigate('/rf/receive');
        break;
      case '02':
        navigate('/rf/putaway');
        break;
      case '99':
        // Handle logoff
        navigate('/');
        break;
      default:
        setError('Invalid selection');
    }
    setInput('');
  };

  return (
    <div className="inbound-container">
      {/* Sidebar */}
      <div className="sidebar">
        <div className="sidebar-header">
          <FaWarehouse className="sidebar-icon" />
          <span>WMS System</span>
        </div>
        <nav className="sidebar-nav">
          <Link to="/inbound-order"><FaBoxes /> Inbound Orders</Link>
          <Link to="/rf" className="active"><FaTerminal /> RF Terminal</Link>
        </nav>
      </div>

      {/* Main Content */}
      <div className="main-content">
        {/* Top Navigation */}
        <header className="top-nav">
          <div className="search-container">
            <input 
              type="text"
              placeholder="Search..."
              className="search-input"
            />
          </div>
          <div className="user-nav">
            <span className="user-name">
              <FaUserCircle /> John Doe
            </span>
            <button onClick={() => navigate('/login')} className="logout-btn">
              <FaSignOutAlt /> Logout
            </button>
          </div>
        </header>

        {/* Page Content */}
        <div className="page-content">
          <div className="content-header">
            <h1>RF Terminal</h1>
          </div>

    <div className="rf-terminal">
      <div className="rf-screen">
        <div className="rf-header">{screen.title}</div>
        <div className="rf-content">
          {screen.menu.map((item, index) => (
            <div key={index} className="rf-menu-item">
              {item.label}
            </div>
          ))}
          <div className="rf-input-line">
            {screen.footer} {input}
          </div>
        </div>
      </div>

      <div className="rf-keypad">
        <div className="rf-keypad-row">
          <button onClick={() => handleKeyPress('7')}>7</button>
          <button onClick={() => handleKeyPress('8')}>8</button>
          <button onClick={() => handleKeyPress('9')}>9</button>
          <button className="function-key">F</button>
        </div>
        <div className="rf-keypad-row">
          <button onClick={() => handleKeyPress('4')}>4</button>
          <button onClick={() => handleKeyPress('5')}>5</button>
          <button onClick={() => handleKeyPress('6')}>6</button>
        </div>
        <div className="rf-keypad-row">
          <button onClick={() => handleKeyPress('1')}>1</button>
          <button onClick={() => handleKeyPress('2')}>2</button>
          <button onClick={() => handleKeyPress('3')}>3</button>
        </div>
        <div className="rf-keypad-row">
          <button onClick={() => handleKeyPress('0')}>0</button>
          <button onClick={() => handleKeyPress('ENT')}>ENT</button>
          <button onClick={() => handleKeyPress('NXT')}>NXT</button>
        </div>
        <div className="rf-keypad-row">
          <button onClick={() => handleKeyPress('BSP')}>BSP</button>
          <button onClick={() => handleKeyPress('CLR')}>CLR</button>
          <button onClick={() => handleKeyPress('EXT')}>EXT</button>
        </div>
      </div>
    </div>
    </div>
    </div>
    </div>  
  );
};

export default RFTerminal; 